import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

/********************************
<Seo />
/********************************
Version: 1
Created: 11 07 2023
Updated: 01 10 2023
Author: Richy Pears
/********************************
Puts the SEO friendly content in
the <head> of the document
/********************************/

const Seo = ({
  children,
  description,
  image,
  noindex,
  prependSitename,
  seo,
  title,
}) => {
  const data = useStaticQuery(graphql`
    query SeoQuery {
      settings: storyblokEntry(full_slug: { eq: "admin/" }) {
        content
        name
        full_slug
        uuid
        id
        internalId
      }
    }
  `)

  const settings = JSON.parse(data?.settings?.content)

  const metaTitle =
    seo?.title || title || settings?.seo?.title || settings?.name
  const metaDescription =
    seo?.description || description || settings?.seo?.description
  const metaImageSource = image?.filename || settings?.seo_image?.filename

  const metaImage =
    metaImageSource?.replace(
      "https://img2.storyblok.com/",
      "https://a.storyblok.com"
    ) + "/m/1200x630"

  const metaImageTwitter =
    metaImageSource?.replace(
      "https://img2.storyblok.com/",
      "https://a.storyblok.com"
    ) + "/m/1200x600"

  return (
    <>
      <title>
        {metaTitle}
        {prependSitename ? ` | ${settings?.name}` : ``}
      </title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metaImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImageTwitter} />
      {noindex ? (
        <>
          <meta name="robots" content="noindex" />
          <meta name="robots" content="nofollow" />
        </>
      ) : (
        ``
      )}
      {children}
    </>
  )
}

export default Seo

Seo.defaultProps = {
  children: null,
  description: null,
  image: null,
  noindex: false,
  prependSitename: false,
  seo: null,
  title: null,
}

Seo.propTypes = {
  children: PropTypes.object,
  description: PropTypes.string,
  image: PropTypes.oneOf,
  noindex: PropTypes.bool,
  prependSitename: PropTypes.bool,
  seo: PropTypes.object,
  title: PropTypes.string,
}
